import axiosInstance from "../Interceptors/ResponseInterceptor";

export const getFeeCategories = async () => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axiosInstance.get("/api/sites");
      resolve(response.data);
    } catch (error) {
      console.error("Error fetching fee categories:", error);
      reject(error);
    }
  });
};
